import type { AxiosRequestConfig } from 'axios';

import { api } from './init';
import type { IHttpResponse } from './types';

const get = async (url: string, config?: AxiosRequestConfig): Promise<IHttpResponse> => {
  try {
    const result = await api.get(url, config);
    return { success: true, data: result.data };
  } catch (error) {
    return { success: false, error };
  }
};

export default get;
